export default {
  setMyCards: (state, cards) => {
    state.myCards = cards;
  },
  setReceivedCards: (state, cards) => {
    state.receivedCards = cards;
  },
  setCardDetail: (state, card) => {
    state.cardDetail = card;
  },
  clearCardDetail: (state) => {
    state.cardDetail = {};
  }
};
